/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { Eyebrow } from "../../icons/Eyebrow";
import { Mouth } from "../../icons/Mouth";
import { ClothingShirtScoop } from "../ClothingShirtScoop";
import { EyesDefault } from "../EyesDefault";
import "./style.css";

export const AvataaarDefault = ({
  className,
  overlapClassName,
  bodyClassName,
  body = "/img/body.png",
  clothingShirtScoopClothingShirtScoop = "/img/clothes.svg",
  clothingShirtScoopClothingShirtScoopClassName,
  faceClassName,
  overlapGroupClassName,
  icon = <Mouth className="mouth-1" opacity="0.7" />,
  mouthStyleOverrideClassName,
  override = <EyesDefault className="eyes-default-instance" />,
  icon1 = <Eyebrow className="eyebrow-instance" />,
  topClassName,
  top = "/img/top.png",
  override1 = (
    <ClothingShirtScoop
      className={clothingShirtScoopClothingShirtScoopClassName}
      clothingShirtScoop={clothingShirtScoopClothingShirtScoop}
    />
  ),
  icon2 = <Mouth className={mouthStyleOverrideClassName} opacity="0.16" />,
}) => {
  return (
    <div className={`avataaar-default ${className}`}>
      <div className={`overlap ${overlapClassName}`}>
        <img className={`body-2 ${bodyClassName}`} alt="Body" src={body} />

        {override1}
        <div className={`face ${faceClassName}`}>
          <div className={`overlap-group-4 ${overlapGroupClassName}`}>
            {icon}
            {icon2}
            {override}
            {icon1}
          </div>
        </div>

        <img className={`top ${topClassName}`} alt="Top" src={top} />
      </div>
    </div>
  );
};

AvataaarDefault.propTypes = {
  body: PropTypes.string,
  clothingShirtScoopClothingShirtScoop: PropTypes.string,
  top: PropTypes.string,
};
